export const API_URL =
  process.env.NEXT_PUBLIC_STFX_API || "https://api.stfx.social";

export const APP_URL =
  process.env.NEXT_PUBLIC_STFX_APP || "https://beta.stfx.io";

export const ARB_APP_URL =
  process.env.NEXT_PUBLIC_STFX_ARB_APP || "https://app.stfx.io";
